import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qgtpeislirecwdmjddhe.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFndHBlaXNsaXJlY3dkbWpkZGhlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg0MDcyMzIsImV4cCI6MjA5Mzk4MzIzMn0.bEcPTxukSTZHqOLKkNpx0g6i0dD4mNRgrxwhws4wMxE';

export const isSupabaseConfigured = true;

// Custom fetch wrapper to dynamically inject tokens on every request
const customFetch = (url: RequestInfo | URL, options?: RequestInit) => {
  const newOptions = options || {};
  
  // Create new headers object to avoid mutating readonly headers
  const headers = new Headers(newOptions.headers || {});
  
  const orgToken = localStorage.getItem('wfm_org_token');
  if (orgToken) headers.set('x-org-token', orgToken);
  
  const managerToken = localStorage.getItem('wfm_manager_token');
  if (managerToken) headers.set('x-manager-token', managerToken);
  
  const teamToken = localStorage.getItem('wfm_staff_token');
  if (teamToken) headers.set('x-staff-token', teamToken);

  newOptions.headers = headers;
  return fetch(url, newOptions);
};

// Single Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    fetch: customFetch
  }
});

// Helper is no longer needed since customFetch reads dynamically from localStorage,
// but we keep it to avoid breaking other files that import it.
export const updateSupabaseHeaders = () => {
  // No-op
};

export { supabaseUrl, supabaseAnonKey };
